export const SVG = 'svg';

export const DEVICE_NAMES = {
  ANDROID: 'android',
  MAC: 'mac',
  WINDOWS: 'windows',
  UBUNTU: 'ubuntu',
};
export const ASC = 'ASC';
export const DESC = 'DESC';

export const REAL_MODE = "real"
export const FUN_MODE = "fun"
